import {Component, Directive, ViewEncapsulation} from '@angular/core';

@Directive({
  selector: 'cyb-footer-content',
  host: {'class': 'cyb-footer-content'}
})
export class CybFooterContentDirective {}

@Directive({
  selector: 'cyb-footer-left',
  host: {'class': 'cyb-footer-left'}
})
export class CybFooterLeftDirective {}

@Directive({
  selector: 'cyb-footer-right',
  host: {'class': 'cyb-footer-right'}
})
export class CybFooterRightDirective {}

@Directive({
  selector: '[cyb-footer-image]',
  host: {'class': 'cyb-footer-image'}
})
export class CybFooterImageDirective {}

/**
 * A basic content container component that adds the styles of a Telefonica design footer.
 *
 * While this component can be used alone, it also provides a number
 * of preset styles for common card sections, including:
 * - cyb-footer-content
 * - cyb-footer-left-image
 * - cyb-footer-right-image
 */
@Component({
  selector: 'cyb-footer',
  template: `<footer class="cyb-footer-container">
  <ng-content></ng-content>
</footer>
`,
  styles: [`.cyb-footer{bottom:0;width:100%;height:40px;margin:10px 0;display:block;box-sizing:border-box;-webkit-box-sizing:border-box;-moz-box-sizing:border-box;position:absolute}.cyb-footer-container{width:95%;padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto;box-sizing:border-box}.cyb-footer-content{margin-top:8px;font-size:12px;color:#003245;text-align:center;width:50%;float:left;position:relative;min-height:1px;padding-right:15px;padding-left:15px;box-sizing:border-box;font-family:Telefonica}.cyb-footer-left,.cyb-footer-right{position:relative;min-height:1px;padding-right:15px;padding-left:15px;width:25%;float:left;box-sizing:border-box}.cyb-footer-right img{float:right}.cyb-footer-image{width:100%;max-width:125px;min-width:125px;vertical-align:middle}`],
  encapsulation: ViewEncapsulation.None,
  host: {'class': 'cyb-footer'}
})

export class CybFooterComponent {}
